// test1008
(1008 && 0);
